import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {clientsStore} from '@store/clients/clients.store';

export const getClientsDataSource = createRequestDataSource({
  store: clientsStore,
  data$: () => clientsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getClients',
  dataKey: 'clients',
});
